import { ResourceResponse } from 'generated/index';
import { useMemo } from 'react';
import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';
import { GridColDef } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

export const useColumnDefinitions = () => {
  const { t } = useTranslation();
  return useMemo<GridColDef<ResourceResponse>[]>(
    () => [
      {
        field: 'active',
        headerName: t('adminPortal.resources.active'),
        type: 'boolean',
        hideable: false,
        minWidth: 80,
        renderCell: BooleanCell
      },
      {
        field: 'code',
        headerName: t('adminPortal.resources.code'),
        hideable: false,
        minWidth: 120
      },
      {
        field: 'name',
        headerName: t('adminPortal.resources.name'),
        hideable: false,
        minWidth: 280
      },
      {
        field: 'description',
        headerName: t('adminPortal.resources.description'),
        hideable: false,
        flex: 1
      }
    ],
    [t]
  );
};

export const isUniqueResourceCode = (
  newCode?: string,
  oldCode?: string,
  resources: readonly ResourceResponse[] = []
) => {
  if (!newCode) {
    return false;
  }

  return (
    !resources.some(
      (resource: ResourceResponse) => resource.code === newCode
    ) || newCode === oldCode
  );
};
